import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/**
 * Scroll handling for every navigation:
 * - with `#id`: scrolls to that section, waiting for it to render (data loads async).
 * - without a hash: opens the new page at the top (footer links, cards, menus…).
 *   Browser back/forward (POP) keeps the browser's own scroll restoration.
 */
export default function ScrollToHash() {
  const { pathname, hash, key } = useLocation();
  const navType = useNavigationType();

  useEffect(() => {
    if (!hash) {
      if (navType !== "POP") window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      return undefined;
    }
    const id = decodeURIComponent(hash.slice(1));
    let tries = 0;
    let timer;
    const tick = () => {
      const el = document.getElementById(id);
      if (el) {
        const y = el.getBoundingClientRect().top + window.scrollY - 80; // fixed header
        window.scrollTo({ top: y, behavior: tries ? "smooth" : "auto" });
        // content above may still be loading and push the section down: re-check a few times
        if (tries < 8) timer = setTimeout(() => { tries += 1; const again = document.getElementById(id); if (again && Math.abs(again.getBoundingClientRect().top - 80) > 4) tick(); }, 300);
        return;
      }
      if (tries++ < 40) timer = setTimeout(tick, 100);
    };
    tick();
    return () => clearTimeout(timer);
    // `key` changes on every navigation, so clicking a link to the page you're on also scrolls
  }, [pathname, hash, key, navType]);
  return null;
}
